import { Dispatch, ReactNode, SetStateAction } from "react";
import EngineConfig from "./engineconfig.tsx";
import AudioConfig from "./audioconfig.tsx";
import ControolerConfig from "./ctrlconfig.tsx";


type NavBarConfigProp = {
    selected: number;
    set_selected:Dispatch<SetStateAction<number>>
}

const NavBarConfig = (props: NavBarConfigProp): ReactNode => {


    switch(props.selected){

        case 1 :return( <EngineConfig setSelectedConf={props.set_selected} />); break;
        case 2 :return( <AudioConfig  setSelectedConf={props.set_selected}/>); break;
        case 3 :return( <ControolerConfig setSelectedConf={props.set_selected}/>); break;


        default:return(<div></div>); break;
    }
 }

 export default NavBarConfig;